import { SupervisionListFontSize } from "../enum/enumCustomInterface";
import { BIGDeviceRelaysQ896S, BIGModeReading } from "../../components/shared-components/enum/enumDevice";
import { LogLevel } from "../../components/shared-components/enum/enumLog";
import { TypeBrightness } from "../enum/enumTypeBrightness";
import { ApplicationTheme } from "../../components/shared-components/enum/enumMisc";
import { BIGInputConfiguration } from "../interface/input-configuration";
import { AppSettings } from "../../components/shared-components/class/general-classes/app-settings";

export class ClientSettings {
  public language: string = "it";
  public supervisionListViewMode: boolean = true;
  public kioskMode: boolean = false;
  public kioskModePassword: string = "1234";
  public deviceName: string = "";
  public idDevice: number = -1;
  /**
   * Default relay which shall be controlled through app if this one is operating in "CONTROL_ACCESS_MODE".
   *
   * ATTENTION: this property is of basic "number" type, since existimg relays depend on peculiar device-type. Inside the code, this property's value
   * shall be converted into the currect enum for the currently used device (see "eumDevice.ts", enums following patterns "BIGDeviceRelays****")
   */
  public defaultRelay: BIGDeviceRelaysQ896S = BIGDeviceRelaysQ896S.NO_RELAY;

  /**
   * Default "activation time". It defines the time period in for which the default relay (as identified in the property "defaultRelay") is electrically stimulated
   * when "active".
   *
   * EXPRESSED IN SECONDS.
   */
  public defaultRelayActivationTime: number = 1;

  /**
   *  This array controls the enabling/disabling of an hard time-limit on each device-integrated relays activation. The lenght of the array is based on
   * the number of keyes present in the "BIGDeviceRelay****" enum defining all the existing device-integrated relay.
   *
   * ATTENTION: Since this type of enums ALSO contains a key for the "not defined"/"no relay" case, the lenght of the array shall actually be:
   *
   * (number of existing relays) + 1
   *
   * And the array's item referring to the first relay shall therefore be defined with index=1.
   */
  public isRelayTimeLimitEnableArray: Array<boolean> = null;

  /**
   * Thi relay contains the extensions of the hard time-limit applied on device-integrated relays; if the app received a relay-manipulation command (IE. open/close) to one of its relays, when the
   * limit expires the opposite command shall be automatically issued to that relay.
   *
   * Expressed in SECONDS.
   *
   *  ATTENTION: Since this type of enums ALSO contains a key for the "not defined"/"no relay" case, the lenght of the array shall actually be:
   *
   * (number of existing relays) + 1
   *
   * And the array's item referring to the first relay shall therefore be defined with index=1.
   */
  public relayTimeLimitArray: Array<number> = null;

  public supervisionFontSize: number = SupervisionListFontSize.MEDIUM;
  public helpAlreadyViewForUser: Map<number, string> = new Map<
    number,
    string
  >();

  public isAutoStartOnBootUpON: boolean = false;
  public remoteLogEnable: boolean = false;
  public remoteLogLevel: LogLevel = LogLevel.LOG_ERROR;

  public input1Configuration: BIGInputConfiguration = null;
  public input2Configuration: BIGInputConfiguration = null;

  public adminDevicePassword: string =
    AppSettings.DEFAULT_DEVICE_ADMIN_PASSWORD;

  /**
   *This property enable/disable the button to authorize the start of log.out process when the connection is considered lost.
   
   NOTE: if it is set to FALSE, the only sure way to "unblock" the app (IE. closing the pop-up and associated overlay) is to re-
   estabilish the connection (since, in case of "auto-login" enabled, even closing the app will not suffice).
   */
  public isConnectionLostExitButtonEnabled: boolean = true;

  /**The custom  Environment category which shall be the first one to be displayed each time an user enter into "My accesses" section.
   *
   * NOTE:This value shall vary based on both the current user and the logged-in plant; as such, it shall be updated at each login/logout.
   * we decided to put this property in "client-settings" and NOT in "settings" for praticality reasons.
   */
  public customStartingAccessEnvironmentCategory: number = -1;

  public theme: ApplicationTheme = ApplicationTheme.UNKNOWN;

  public isDigitalPlace: boolean = false;
  public enableBrightnessSettings: boolean = false;
  public typeBrightnessSettings: TypeBrightness = -1;
  public timeBrightness: number = 60;
  public percentageBrightness: number = 0;
  public defaultBrightness: number = 100;
  public timeInactivitySupervision: number = 0;
  public cardReadingMode: BIGModeReading = 0;
  public numberEventsBlackBox: number = 500;

  constructor(clientSettingsType?: any) {
    // used for assign type to instance of object
    if (clientSettingsType) {
      Object.assign(this, clientSettingsType);
    }
  }
}
